'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright 2017, IOOF Holdings Limited.
                                                                                                                                                                                                                                                                   * All rights reserved.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _redux = require('redux');

var _reduxConcatenateReducers = require('redux-concatenate-reducers');

var _reduxConcatenateReducers2 = _interopRequireDefault(_reduxConcatenateReducers);

var _filteredReducer = require('./filteredReducer');

var _filteredReducer2 = _interopRequireDefault(_filteredReducer);

var _createDynamicReducer = require('./createDynamicReducer');

var _createDynamicReducer2 = _interopRequireDefault(_createDynamicReducer);

var _flattenReducers = require('./flattenReducers');

var _flattenReducers2 = _interopRequireDefault(_flattenReducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_REDUCER = function DEFAULT_REDUCER(state) {
    return state;
};

var createStore = function createStore(reducer) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
    }

    var dynamicReducers = {};

    var createReducer = function createReducer() {
        var reducers = [];

        if (reducer) {
            reducers.push((0, _filteredReducer2.default)(reducer));
        }

        if (Object.keys(dynamicReducers).length !== 0) {
            reducers.push((0, _createDynamicReducer2.default)(dynamicReducers));
        }

        return Object.keys(reducers).length > 0 ? (0, _reduxConcatenateReducers2.default)(reducers) : DEFAULT_REDUCER;
    };

    var attachReducers = function attachReducers(reducers) {
        dynamicReducers = _extends({}, dynamicReducers, (0, _flattenReducers2.default)(reducers));
        store.replaceReducer(createReducer());
    };

    var store = _redux.createStore.apply(undefined, [createReducer()].concat(rest));

    store.attachReducers = attachReducers;

    return store;
};

exports.default = createStore;